export default __webpack_public_path__ + "assets/instagram-off.71317ab9.png";